import { useRef } from "react";
export function useLazyServiceFactoryRef(serviceFactory, storage, update) {
    const ref = useRef(undefined);
    if (ref.current === undefined) {
        ref.current = serviceFactory(storage, update);
    }
    return ref;
}
